import i18next from "i18next"
import { lazy } from "react"
import { RouteObject } from "react-router-dom"

const HomeIndex = lazy(() => import("@/pages/Home/HomeIndex"))

const route: RouteObject = {
  path: "/",
  element: <HomeIndex />,
  handle: {
    title: () => i18next.t("pageTitle", { ns: "dashboard" }),
  },
}

export default route
